import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createLocationOverrideRule } from '../../../api/plan-location-override-rules-api'
import type {
  CreatePlanLocationOverrideRuleRequestDto,
  PlanLocationOverrideRuleResponseDto,
} from '../../../api/dto/plan-location-override-rules.dto'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'

export function useCreateLocationOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<
    PlanLocationOverrideRuleResponseDto,
    unknown,
    CreatePlanLocationOverrideRuleRequestDto
  >({
    mutationFn: (body) => createLocationOverrideRule(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
